import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set title immediately before React mounts
document.title = 'Megapack Nutrición Resuelta — Consulta Resuelta™';
// Preconnect to critical origins BEFORE React renders
const origins = [{
  href: 'https://res.cloudinary.com',
  crossOrigin: 'anonymous'
}, {
  href: 'https://cdn.magicpatterns.com',
  crossOrigin: 'anonymous'
}];
origins.forEach(({
  href,
  crossOrigin
}) => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (crossOrigin) link.crossOrigin = crossOrigin;
  document.head.appendChild(link);
});
// Preload hero image for faster LCP — must match the actual src in App.tsx
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_800/v1777093304/hf_20260425_045722_0df0661c-74fd-494d-bff6-ad09b96d8013-Photoroom_yjahzb.png';
document.head.appendChild(preloadImg);
render(<App data-id="element-376" />, document.getElementById('root'));